// @owners { team: patients }

// A window is only bypassable if the payload actually carries a bypass_token — an absent payload
// token means no bypass is possible, regardless of what's persisted locally.
export const isBypassed = (persistedToken: string | undefined | null, payloadToken: string | undefined): boolean => {
  if (!payloadToken) return false;
  return persistedToken === payloadToken;
};
